export function selectStories(reduxStore) {
  return reduxStore.allStories.allStories;
}
